module.exports = __webpack_public_path__ + "img/manybot.b4a61708.png";